<ng-container>
	@if (zoomValue !== undefined) {
		<div class="zoomToolbar">
			<button
				[disabled]="bottomBoundaryReached"
				class="{{ zoomToolbarIconClasses().fitToPage }} diagramIcons remove-on-small-devices"
				(click)="fitToPageButtonClicked()"
				title="{{ 'fitToPage' | translate }}"
			></button>
			<button
				[disabled]="bottomBoundaryReached"
				class="{{ zoomToolbarIconClasses().oneStepDown }} diagramIcons"
				(click)="stepButtonClicked(Step.Down)"
				title="{{ 'process.diagram.zoomtool.zoomout' | translate }}"
			></button>
			<span class="h3 zoomText remove-on-small-devices">{{ zoomValue }}%</span>
			<button
				[disabled]="topBoundaryReached"
				class="{{ zoomToolbarIconClasses().oneStepUp }} diagramIcons"
				(click)="stepButtonClicked(Step.Up)"
				title="{{ 'process.diagram.zoomtool.zoomin' | translate }}"
			></button>
		</div>
	}
</ng-container>
